(function(){
  function qs(s,c){return (c||document).querySelector(s)}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  function lockHeader(){
    var h=qs('.site-header');
    if(!h) return;
    h.style.position='fixed';
    h.style.top='0'; h.style.left='0'; h.style.right='0'; h.style.width='100%';
    h.style.zIndex='2147483000'; h.style.transform='none'; h.style.opacity='1'; h.style.visibility='visible';
    var height=h.offsetHeight || 72;
    document.documentElement.style.setProperty('--header-h', height+'px');
    document.body.style.paddingTop=height+'px';
  }
  function initDrawer(){
    var open=qs('[data-drawer-open]'), close=qs('[data-drawer-close]'), drawer=qs('[data-drawer]');
    if(!drawer||!open) return;
    if(open.dataset.bound==='true') return;
    open.dataset.bound='true';
    function show(){drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');open.setAttribute('aria-expanded','true');document.body.classList.add('drawer-open')}
    function hide(){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');open.setAttribute('aria-expanded','false');document.body.classList.remove('drawer-open')}
    open.addEventListener('click',show);
    if(close) close.addEventListener('click',hide);
    document.addEventListener('keydown',function(e){if(e.key==='Escape') hide()});
    qsa('a', drawer).forEach(function(a){a.addEventListener('click',hide)});
  }
  function initDetails(){
    qsa('details[data-single-open]').forEach(function(d){
      if(d.dataset.bound==='true') return; d.dataset.bound='true';
      d.addEventListener('toggle',function(){if(d.open){qsa('details[data-single-open]', d.parentNode).forEach(function(o){if(o!==d)o.open=false})}})
    })
  }
  function money(cents){
    if(window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return (cents/100).toLocaleString(undefined,{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'});
  }
  function initProductForms(){
    qsa('[data-product-section]').forEach(function(section){
      if(section.dataset.variantBound==='true') return; section.dataset.variantBound='true';
      var variants=[];
      try{variants=JSON.parse(section.getAttribute('data-product-json')||'[]')}catch(e){variants=[]}
      var form=qs('form[action*="/cart/add"], form[action$="/cart/add"]', section) || qs('.product-form', section);
      var idInput=qs('[data-variant-id]', section);
      var mobileInput=qs('[data-mobile-variant-id]');
      var atc=qs('[data-add-to-cart]', section);
      var mobileBtn=qs('[data-mobile-atc-button]');
      var priceEl=qs('.product-price', section);
      function selectedOptions(){
        var out=[];
        qsa('.variant-fieldset', section).forEach(function(fs){
          var checked=qs('input[type="radio"]:checked', fs);
          if(checked) out.push(checked.value);
        });
        return out;
      }
      function findVariant(){
        if(!variants.length) return null;
        var selected=selectedOptions();
        if(!selected.length) return variants[0];
        return variants.find(function(v){return selected.every(function(val,i){return v.options && v.options[i]===val})}) || null;
      }
      function sync(){
        var v=findVariant();
        if(!v) return;
        if(idInput) idInput.value=v.id;
        if(mobileInput) mobileInput.value=v.id;
        if(priceEl && typeof v.price !== 'undefined') priceEl.innerHTML=money(v.price);
        var available=!!v.available;
        if(atc){atc.disabled=!available; atc.textContent=available?'Add to cart':'Sold out'}
        if(mobileBtn){mobileBtn.disabled=!available; mobileBtn.textContent=available?'Add':'Sold out'}
      }
      qsa('.variant-fieldset input[type="radio"]', section).forEach(function(input){input.addEventListener('change',sync)});
      sync();
    });
  }
  function initAll(){lockHeader();initDrawer();initDetails();initProductForms()}
  document.addEventListener('DOMContentLoaded',initAll);
  window.addEventListener('resize',lockHeader,{passive:true});
  window.addEventListener('scroll',lockHeader,{passive:true});
  document.addEventListener('shopify:section:load',initAll);
})();
